module.exports = __webpack_public_path__ + "static/img/logo04.2b1e7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo04.png
// module id = eQVg
// module chunks = 0